import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'mdk-contact-button',
  templateUrl: './contact-button.component.html'
})
export class ContactButtonComponent implements OnInit {
  @Input() path = '/';

  contactUsUrl: string = 'https://www.agentschapmdk.be/nl/contact';

  ngOnInit() { }
}
